export class ResponseModel{
    statusCode: number;
    status:number;
    message: string;
    responseData:string;
    decryptResponse:string    
    idVariable: number;
    extraVariable: string;
    responseObject: any;
    respList: Array<any>;
    respArray: String[];
}